import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

class CampaignsEditForm extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        initialize({
            name: data.name,
            user_id: data.user_id,
        });
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            invalid,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.campaigns.fields.name') }
                                    name='name'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

CampaignsEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(CampaignsEditForm);



// WEBPACK FOOTER //
// ./src/pages/campaigns/edit/CampaignsEditForm.js